import { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function SessionReportView({ report, onClose }) {
  const [annotation, setAnnotation] = useState('')
  const [saving, setSaving] = useState(false)

  const handleAddAnnotation = async () => {
    if (!annotation.trim()) return
    setSaving(true)
    const { data: { user } } = await supabase.auth.getUser()
    await supabase.from('report_annotations').insert({
      report_id: report.id,
      author_id: user.id,
      author_role: 'pro',
      content: annotation,
    })
    setAnnotation('')
    setSaving(false)
  }

  const statusLabel = (status) => {
    if (status === 'draft') return { label: 'Brouillon', color: '#94a3b8' }
    if (status === 'pending_parent') return { label: 'En attente parent', color: '#f59e0b' }
    if (status === 'validated') return { label: 'Validé', color: '#10b981' }
  }

  const s = statusLabel(report.status)

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#fff', borderRadius: '16px', width: '100%', maxWidth: '720px',
        maxHeight: '90vh', overflow: 'auto', padding: '32px', position: 'relative'
      }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px' }}>
          <div>
            <h2 style={{ margin: '0 0 6px', fontSize: '20px', fontWeight: '700', color: '#1e293b' }}>
              📋 {report.subject}
            </h2>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              <span style={{ fontSize: '13px', color: '#94a3b8' }}>
                {new Date(report.created_at).toLocaleDateString('fr-FR', {
                  day: '2-digit', month: 'long', year: 'numeric'
                })}
              </span>
              <span style={{
                padding: '2px 10px', borderRadius: '20px', fontSize: '12px',
                fontWeight: '600', backgroundColor: s.color + '20', color: s.color
              }}>
                {s.label}
              </span>
            </div>
          </div>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#94a3b8'
          }}>×</button>
        </div>

        {/* Compte rendu général */}
        <div style={{
          backgroundColor: '#f8fafc', borderRadius: '12px', padding: '20px', marginBottom: '24px'
        }}>
          <h3 style={{ margin: '0 0 12px', fontSize: '15px', fontWeight: '600', color: '#374151' }}>
            Compte rendu général
          </h3>
          <div
            style={{ fontSize: '14px', lineHeight: '1.7', color: '#1e293b' }}
            dangerouslySetInnerHTML={{ __html: report.content }}
          />
        </div>

        {/* Blocs additionnels */}
        {report.report_blocks && report.report_blocks.length > 0 && (
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ margin: '0 0 12px', fontSize: '15px', fontWeight: '600', color: '#374151' }}>
              Éléments additionnels
            </h3>
            {report.report_blocks.map(block => (
              <div key={block.id} style={{
                border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px',
                marginBottom: '10px', backgroundColor: '#fff'
              }}>
                <p style={{ margin: '0 0 6px', fontWeight: '600', color: '#374151', fontSize: '14px' }}>
                  {block.title}
                </p>
                {block.content && (
                  <p style={{ margin: '0 0 8px', fontSize: '13px', color: '#64748b', lineHeight: '1.6' }}>
                    {block.content}
                  </p>
                )}
                {block.document_url && (
                  <a href={block.document_url} target="_blank" rel="noreferrer" style={{
                    fontSize: '12px', color: '#667eea', textDecoration: 'none'
                  }}>
                    📎 Voir le document joint
                  </a>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Annotation */}
        <div style={{
          borderTop: '1px solid #e2e8f0', paddingTop: '20px', marginTop: '8px'
        }}>
          <h3 style={{ margin: '0 0 10px', fontSize: '15px', fontWeight: '600', color: '#374151' }}>
            Ajouter une note
          </h3>
          <p style={{ margin: '0 0 10px', fontSize: '12px', color: '#94a3b8' }}>
            Les notes ajoutées après validation sont horodatées et visibles de tous les destinataires.
          </p>
          <textarea
            value={annotation}
            onChange={e => setAnnotation(e.target.value)}
            placeholder="Ajouter une observation, une précision..."
            rows={3}
            style={{
              width: '100%', padding: '10px 14px', borderRadius: '8px',
              border: '1px solid #e2e8f0', fontSize: '13px', resize: 'vertical',
              boxSizing: 'border-box', marginBottom: '10px'
            }}
          />
          <button
            onClick={handleAddAnnotation}
            disabled={saving || !annotation.trim()}
            style={{
              padding: '8px 20px', borderRadius: '8px', border: 'none',
              backgroundColor: '#667eea', color: '#fff', cursor: 'pointer',
              fontSize: '13px', fontWeight: '600', opacity: saving ? 0.6 : 1
            }}
          >
            {saving ? 'Enregistrement...' : 'Ajouter la note'}
          </button>
        </div>
      </div>
    </div>
  )
}